var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlExtDirectPaymentAtTheHotelOutlined = function SvgHtlExtDirectPaymentAtTheHotelOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.997 3.063c1.792 0 3.461.529 4.86 1.438.23.149.248.47.079.684a.513.513 0 0 1-.67.124A7.936 7.936 0 0 0 4.062 12a7.937 7.937 0 0 0 7.934 7.94 7.937 7.937 0 0 0 7.932-8.148.516.516 0 0 1 .456-.51c.271-.035.532.149.542.422.003.099.005.198.005.297l-.012.46c-.239 4.723-4.143 8.479-8.923 8.479l-.46-.012A8.937 8.937 0 0 1 3.063 12c0-4.936 4-8.937 8.935-8.937Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "m17 9.877 3.237-3.237"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M17.766 6.5h2.59V9M11.997 8.39c-1.329 0-2.406.809-2.406 1.806 0 .996 1.077 1.805 2.406 1.805 1.329 0 2.405.808 2.405 1.804 0 .997-1.076 1.805-2.405 1.805m0-7.219c1.047 0 1.938.502 2.269 1.203m-2.27-1.203V7.188m0 8.422c-1.046 0-1.938-.502-2.268-1.203m2.269 1.203v1.203"
  })));
};
export default SvgHtlExtDirectPaymentAtTheHotelOutlined;